module.exports = __webpack_public_path__ + "img/especiais.7d61f54c.svg";